import { render } from "./PhysicianItem.vue?vue&type=template&id=4e849fc0&scoped=true"
import script from "./PhysicianItem.vue?vue&type=script&lang=js"
export * from "./PhysicianItem.vue?vue&type=script&lang=js"

import "./PhysicianItem.vue?vue&type=style&index=0&id=4e849fc0&scoped=true&lang=scss"
import "./PhysicianItem.vue?vue&type=style&index=1&id=4e849fc0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e849fc0"]])

export default __exports__